/**
 * QuotaModal Component
 * 
 * Analiz hakkı limiti dolduğunda gösterilen uyarı modalı.
 */

import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

export const QuotaModal = ({
  isOpen,
  onClose,
  onUpgrade
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/90 backdrop-blur-md flex items-center justify-center z-50 p-4"
      data-testid="quota-modal"
    >
      <Card className="w-full max-w-lg bg-gray-900 border-red-500 border-2 shadow-2xl relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
          aria-label={t('common.close')}
          data-testid="quota-modal-close"
        >
          <X className="h-6 w-6" />
        </button>
        
        <CardHeader className="text-center pb-4">
          <CardTitle className="text-red-400 text-3xl font-bold mb-2">
            ⚠️ {t('modals.quota_title')}
          </CardTitle>
        </CardHeader>
        
        <CardContent className="text-center space-y-6 pt-2">
          <Button
            onClick={onUpgrade}
            className="w-full bg-[#FFDD59] hover:bg-[#E6C84D] text-black font-bold py-4 text-xl"
            data-testid="quota-modal-upgrade"
          >
            🛒 {t('modals.quota_buy')}
          </Button>
          
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white text-sm underline"
            data-testid="quota-modal-later"
          >
            {t('modals.quota_later')}
          </button>
        </CardContent>
      </Card>
    </div>
  );
};

export default QuotaModal;
